import { createReducer } from '../utils/createReducer'
import { request, jumpToOAuth2 } from "../utils/request";

const namespace: string = 'session';

const initialState = {
  isSsoLogedIn: false,
  ssoUserInfo: {},
  userInfo: {},
  isLoggedIn: false,
};


const reducer = {
  getSsoUserInfo(state = initialState, action: any) {
    if (action.error || action.result.error) {
      return {
        ...state,
        isSsoLogedIn: false,
      }
    }

    return {
      ...state,
      ssoUserInfo: action.result,
      isSsoLogedIn: true,
    };
  },
  getUserInfo(state = initialState, action: any) {

    if (action.error || action.result.error) {

      // 如果用户没有登录, 而且用户的环境是在宝盒中, 应当登录, 就直接跳
      {
        const params = new URLSearchParams(window.location.search);
        console.log('params: ', params);
        const notAuthorized= params.get('authorized') === 'false';
        console.log('getUserInfo notAuthorized: ', notAuthorized);
        console.log('getUserInfo navigator.userAgent: ', navigator.userAgent);
        if (!notAuthorized && action.result && action.result.error === "need_login_first") {
          if (state.isSsoLogedIn || /ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
            // 为防止不明原因导致可能存在的无限跳转, 需要额外记录上次刷新时间, 如果在5秒之内, 就不再刷新
            const lastLogin = localStorage.getItem("lastLogin");
            if (lastLogin !== null) {
              const lastTime = parseInt(lastLogin)
              const nowDate = Date.now();
              if (nowDate - lastTime < 1000 * 5) {
                // 不跳转
                return { ...state, userInfo: {} }
              }
            }
            const nowDate = Date.now();
            localStorage.setItem("lastLogin", "" + nowDate);
            jumpToOAuth2();
          }
        }
      }
      return { ...state, userInfo: {} }
    }

    return { ...state, userInfo: action.result || {}, isLoggedIn: true };
  },

};

export default createReducer(initialState, reducer, namespace);








// WEBPACK FOOTER //
// ./src/reducers/session.ts